'use strict';

angular.module('formonlineApp').service('WhitelistService', ['$http',
    function ($http) {
        this.check = function (nDC, annee, type, code, successFn, errorFn) {
            var params = {
                nDC: nDC,
                annee: annee,
                type: type,
                code: code
            };
            $http({
                method: 'get',
                url: 'api/whitelist/check',
                params: params
            }).success(successFn).error(errorFn);
        };
    }]);
